export default __webpack_public_path__ + "static/media/seach_btn.b58e67dd.svg";